import { create } from 'zustand';
import type { ChatMessage, ChatScope } from '@etown/shared';
import { CHAT_BUFFER_LIMIT } from '../lib/constants';

interface ChatState {
  messages: ChatMessage[];
  activeScope: ChatScope;
  isOpen: boolean;
  unread: number;
  hasMore: boolean;
  setHistory: (messages: ChatMessage[], hasMore: boolean) => void;
  prependHistory: (messages: ChatMessage[], hasMore: boolean) => void;
  addMessage: (message: ChatMessage) => void;
  setScope: (scope: ChatScope) => void;
  setOpen: (open: boolean) => void;
  reset: () => void;
}

/** Chat-Verlauf und UI-Zustand des Chat-Panels. */
export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  activeScope: 'global',
  isOpen: false,
  unread: 0,
  hasMore: false,

  setHistory: (messages, hasMore) => set({ messages, hasMore }),

  prependHistory: (older, hasMore) =>
    set((state) => ({ messages: [...older, ...state.messages], hasMore })),

  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages.slice(-CHAT_BUFFER_LIMIT + 1), message],
      unread: state.isOpen ? 0 : state.unread + 1,
    })),

  setScope: (scope) => set({ activeScope: scope }),
  setOpen: (open) => set((state) => ({ isOpen: open, unread: open ? 0 : state.unread })),
  reset: () => set({ messages: [], unread: 0, hasMore: false }),
}));
